import requester from '@/lib/axios';
import { ActivityBlockType } from '@/models/Activity';
import {
  ActivityCorrectionStatusEnum,
  ActivityProgress,
} from '@/models/ActivityProgress';
import { OrderingFrom } from '@/models/Filter';
import JsonApiResponse from '@/models/JsonApiResponse';
import { BaseFilters } from '@/models/Service';

const baseUrl = 'activity-progress';

export const ACTIVITY_PROGRESS_ORDERING_FIELDS = ['sent_at'] as const;

export type ActivityProgressOrdering = OrderingFrom<
  typeof ACTIVITY_PROGRESS_ORDERING_FIELDS
>;

export interface ActivityProgressFilterParams extends BaseFilters {
  activityId?: number[];
  userId?: number[];
  isActive?: boolean;
  courseProgressId?: number;
  activityType?: ActivityBlockType[];
  klassId?: number[];
  unitId?: number[];
  teacherId?: number[];
  lessonId?: number[];
  correctionStatus?: ActivityCorrectionStatusEnum[];
  sentAtAfter?: string;
  sentAtBefore?: string;
  ordering?: ActivityProgressOrdering;
}

export const getActivityProgress = async (activityProgressId: number) => {
  const { data } = await requester().get<ActivityProgress>(
    `${baseUrl}/${activityProgressId}/`,
  );

  return data;
};

export const listActivityProgress = async (
  params: ActivityProgressFilterParams = {},
) => {
  const { data } = await requester().get<JsonApiResponse<ActivityProgress>>(
    `${baseUrl}/`,
    { params },
  );

  return data;
};

export const updateActivityProgress = async (
  activityProgressId: number,
  activityProgress: Partial<ActivityProgress>,
) => {
  const { data } = await requester().patch<ActivityProgress>(
    `${baseUrl}/${activityProgressId}/`,
    activityProgress,
  );

  return data;
};
